module.exports = __webpack_public_path__ + "static/img-management-3805ca839a77d7997e9066ae2c19e50f.png";